import { render, staticRenderFns } from "./fileselector.vue?vue&type=template&id=7042957e&scoped=true"
import script from "./fileselector.vue?vue&type=script&lang=ts"
export * from "./fileselector.vue?vue&type=script&lang=ts"
import style0 from "./fileselector.vue?vue&type=style&index=0&id=7042957e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7042957e",
  null
  
)

export default component.exports